<div class="row" [formGroup]="formGroup">
	<div class="col-sm-6">
		<eze-input-container>
			<input
				ezeInput
				type="text"
				id="email"
				[showValidation]="showValidation"
				formControlName="email"
			/>
		</eze-input-container>
	</div>
	<div class="col-sm-6">
		<eze-input-container>
			<input
				ezeInput
				type="text"
				id="phone"
				[showValidation]="showValidation"
				formControlName="phone"
				[textMask]="{ mask: getPhoneMask('phone'), guide: false }"
			/>
		</eze-input-container>
	</div>

	<!-- address -->
	<div class="col-sm-12" *ngIf="isStandardEvent">
		<eze-input-container>
			<input
				ezeInput
				type="text"
				id="address"
				[showValidation]="showValidation"
				formControlName="address"
			/>
		</eze-input-container>
	</div>

	<div class="col-sm-12" *ngIf="isStandardEvent">
		<eze-input-container>
			<input
				ezeInput
				type="text"
				id="address_2"
				[showValidation]="showValidation"
				formControlName="address_2"
			/>
		</eze-input-container>
	</div>

	<div class="col-sm-5" *ngIf="isStandardEvent">
		<eze-input-container>
			<input
				ezeInput
				type="text"
				id="city"
				[showValidation]="showValidation"
				formControlName="city"
			/>
		</eze-input-container>
	</div>

	<div class="col-xs-6 col-sm-3" *ngIf="isStandardEvent">
		<eze-input-container>
			<select
				ezeInput
				id="state"
				[showValidation]="showValidation"
				formControlName="state"
			>
				<option value="">Select...</option>
				<option *ngFor="let state of stateList" [value]="state">
					{{ state }}
				</option>
			</select>
		</eze-input-container>
	</div>

	<div class="col-xs-6 col-sm-4" *ngIf="isStandardEvent">
		<eze-input-container>
			<input
				ezeInput
				type="text"
				id="zip"
				[showValidation]="showValidation"
				formControlName="zip"
			/>
		</eze-input-container>
	</div>
</div>
